import {
  postForgetPassword,
  postResetPassword,
  postUserCheckCodeForget,
} from "@/api/signin";
import { EyeClosedIcon, EyeOpenIcon, ProfileIcon } from "@/assets";
import { AsarButton, AsarFormikInput, Loader } from "@/components";
import Timer from "@/components/signin/timer";
import { Button, Grid, IconButton, Typography } from "@mui/material";
import { Form, Formik } from "formik";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import VerificationInput from "react-verification-input";
import * as Yup from "yup";

export default function ForgetPassForm({ level, setLevel }) {
  const [valueNID, setValueNID] = useState();

  const [code, setCode] = useState();
  const [token, setToken] = useState();
  const [reminder, setReminder] = useState();
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordRep, setShowPasswordRep] = useState(false);

  const navigate = useNavigate();

  const onSubmit = async (values, actions) => {
    postForgetPassword({ nid: values.nid })
      .then((x) => {
        setToken(x.token);
        setReminder(x.reminder);
        setLevel(2);
        setValueNID(values.nid);
      })
      .catch(() => {})
      .finally(() => {
        actions.setSubmitting(false);
      });
  };

  const onChangePass = async (values, actions) => {
    postResetPassword({
      token: token,
      nid: valueNID,
      code: Number(code),
      password: values.newPass,
      repeatPassword: values.newPassRep,
    })
      .then(() => {
        toast.success("رمزعبور با موفقیت به روزرسانی شد");
        navigate("/login");
      })
      .catch(() => {})
      .finally(() => {
        actions.setSubmitting(false);
      });
  };

  const setPasswordValidationSchema = Yup.object({
    newPass: Yup.string()
      .min(6, "رمزعبور باید حداقل 6 کاراکتر باشد")
      .required("لطفا رمزعبور را وارد نمایید"),

    newPassRep: Yup.string()
      .oneOf([Yup.ref("newPass"), null], "رمزعبور با تکرار آن یکسان نیست")
      .required("لطفا تکرار رمزعبور را وارد نمایید"),
  });

  return (
    <>
      {level === 1 && (
        <>
          <Formik
            initialValues={{
              nid: "",
            }}
            onSubmit={onSubmit}
            validateOnBlur={false}
            validateOnChange={false}
          >
            {({ isSubmitting, submitForm }) => (
              <Form
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <AsarFormikInput
                  name={"nid"}
                  label="کدملی"
                  placeholder={"کدملی خود را بنویسید"}
                >
                  <ProfileIcon />
                </AsarFormikInput>
                {isSubmitting && <Loader />}
                {!isSubmitting && (
                  <Grid
                    mt={"20px"}
                    display={"flex"}
                    flexDirection={"column"}
                    justifyContent={"center"}
                  >
                    <Button variant="contained" onClick={submitForm}>
                      ارسال کد
                    </Button>
                    <Button
                      onClick={() => navigate("/login")}
                      sx={{ color: "var(--emr-text-bold)" }}
                      variant="text"
                    >
                      بازگشت به فرم ورود
                    </Button>
                  </Grid>
                )}
              </Form>
            )}
          </Formik>
        </>
      )}
      {level === 2 && (
        <>
          <VerificationInput
            onChange={setCode}
            length={6}
            validChars="0-9"
            removeDefaultStyles
            classNames={{
              container: "container",
              character: "character",
              characterInactive: "character--inactive",
              characterSelected: "character--selected",
            }}
          />

          <AsarButton
            onClick={() => {
              if (code) {
                postUserCheckCodeForget({
                  token: token,
                  nid: valueNID,
                  code: code,
                }).then(() => setLevel(3));
              }
            }}
          >
            <Typography fontSize="16px" color="white" ml="10px">
              تایید کد
            </Typography>
          </AsarButton>
          <Timer
            initialMinute={Math.floor(reminder / 60)}
            initialSeconds={reminder % 60}
          />
          <Button
            onClick={() => setLevel(1)}
            variant="text"
            sx={{ color: "var(--emr-text-bold)" }}
          >
            ویرایش کدملی
          </Button>
        </>
      )}
      {level === 3 && (
        <>
          <Formik
            initialValues={{
              newPass: "",
              newPassRep: "",
            }}
            validationSchema={setPasswordValidationSchema}
            onSubmit={onChangePass}
            validateOnBlur={false}
            validateOnChange={false}
          >
            {({ isSubmitting, submitForm }) => (
              <Form
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  gap: "20px",
                }}
              >
                <AsarFormikInput
                  type={showPassword ? "text" : "password"}
                  name={"newPass"}
                  showResetPassword={false}
                  label="رمزعبور جدید"
                  placeholder={"رمزعبور جدید خود را بنویسید."}
                  endAdornment={
                    <IconButton
                      onClick={() => setShowPassword(!showPassword)}
                      edge="end"
                      aria-label={showPassword ? "مخفی کردن رمز" : "نمایش رمز"}
                    >
                      {showPassword ? <EyeClosedIcon /> : <EyeOpenIcon />}
                    </IconButton>
                  }
                />
                <AsarFormikInput
                  type={showPasswordRep ? "text" : "password"}
                  showResetPassword={false}
                  name={"newPassRep"}
                  label="تکرار - رمزعبور جدید"
                  placeholder={"تکرار - رمزعبور جدید خود را بنویسید."}
                  endAdornment={
                    <IconButton
                      onClick={() => setShowPasswordRep(!showPasswordRep)}
                      edge="end"
                      aria-label={
                        showPasswordRep ? "مخفی کردن رمز" : "نمایش رمز"
                      }
                    >
                      {showPasswordRep ? <EyeClosedIcon /> : <EyeOpenIcon />}
                    </IconButton>
                  }
                />
                {isSubmitting && <Loader />}
                {!isSubmitting && (
                  <Button variant="contained" onClick={submitForm}>
                    بروزرسانی رمز
                  </Button>
                )}
              </Form>
            )}
          </Formik>
        </>
      )}
    </>
  );
}
